import React from 'react';
import { ArrowUpRight, Mail, CalendarDays, Trophy } from 'lucide-react';
import { siteConfig, freelancerStats } from '../data/mock';
import { Logo, WhatsAppIcon, TelegramIcon } from './Brand';

const links = [
  { href: '#services', label: 'Services' },
  { href: '#process', label: 'Process' },
  { href: '#about', label: 'About' },
  { href: '#reviews', label: 'Reviews' },
  { href: '#contact', label: 'Contact' }
];

const Footer = () => (
  <footer className="bg-ink text-white relative overflow-hidden" data-testid="site-footer">
    <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)', backgroundSize: '32px 32px' }} />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
      <div className="grid lg:grid-cols-12 gap-12 pb-14 border-b border-white/10">
        <div className="lg:col-span-5">
          <Logo light />
          <p className="text-white/65 leading-relaxed mt-6 max-w-sm">
            Cold email outreach, email infrastructure and verified B2B leads — built and run by {siteConfig.personName}.
          </p>
          <a href={siteConfig.freelancerProfile} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 mt-7 pl-1.5 pr-4 py-1.5 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-colors" data-testid="footer-top3-badge">
            <span className="w-8 h-8 rounded-full bg-[#10B981] flex items-center justify-center"><Trophy className="w-4 h-4 text-white" /></span>
            <span className="text-sm text-white/85">Preferred Freelancer · {freelancerStats.rank} {freelancerStats.rankOf}</span>
          </a>
        </div>

        <div className="lg:col-span-3">
          <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-5">Navigate</p>
          <ul className="space-y-3">
            {links.map((l) => (
              <li key={l.href}><a href={l.href} className="text-white/75 hover:text-white transition-colors" data-testid={`footer-link-${l.label.toLowerCase()}`}>{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-5">Reach me</p>
          <ul className="space-y-3">
            <li><a href={siteConfig.calendly} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/75 hover:text-white transition-colors" data-testid="footer-book-call-link"><CalendarDays className="w-4 h-4 text-[#10B981]" /> Book a 30-min call</a></li>
            <li><a href={`https://wa.me/${siteConfig.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/75 hover:text-white transition-colors" data-testid="footer-whatsapp-link"><WhatsAppIcon className="w-4 h-4 text-[#25D366]" /> {siteConfig.phone}</a></li>
            <li><a href={`https://t.me/${siteConfig.telegram}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/75 hover:text-white transition-colors" data-testid="footer-telegram-link"><TelegramIcon className="w-4 h-4 text-[#229ED9]" /> @{siteConfig.telegram}</a></li>
            <li><a href={`mailto:${siteConfig.email}`} className="flex items-center gap-3 text-white/75 hover:text-white transition-colors" data-testid="footer-email-link"><Mail className="w-4 h-4 text-white/60" /> {siteConfig.email}</a></li>
            <li><a href={siteConfig.freelancerProfile} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/75 hover:text-white transition-colors" data-testid="footer-freelancer-link"><ArrowUpRight className="w-4 h-4 text-white/60" /> freelancer.com/u/usamatausif</a></li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-8 text-sm text-white/45">
        <p>© {new Date().getFullYear()} {siteConfig.name}. All rights reserved.</p>
        <p className="font-mono text-xs">SPF ✓ DKIM ✓ DMARC ✓ — delivered from Pakistan to inboxes worldwide.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
